<template>
  <el-dialog
    title="请使用手机扫码答题"
    :visible.sync="dialogVisible"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
  >
    <div class="dialog-content">
      <vue-qr ref="qr" :text="qr" :size="400"></vue-qr>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button type="primary">下载二维码</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
import secret from "@/publicFunction/secret";
import vueQr from "vue-qr";
export default {
  name: "QuestionBankQr",
  components: {
    vueQr
  },
  props: {
    qrResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    questionOrder: {
      type: Number,
      default: {
        return: 0
      }
    },
    type: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      qr: "",
      base: this.$store.state.config.base
    };
  },
  created() {},
  mounted() {},
  watch: {
    qrResize: function(newVal, oldVal) {
      if (newVal) {
        let userInfo = this.$store.getters.getUserInfo;
        let questionBankId = this.questionOrder;
        let type = this.type;
        // console.log(userInfo, questionBankId);
        let info = questionBankId + "&" + type + "&" + JSON.stringify(userInfo);
        // console.log(info);
        // console.log(secret.Encrypt(info));
        let secretInfo = secret.Encrypt(info);

        this.qr = this.base + "?info=" + secretInfo;
        // console.log(this.qr)
        this.dialogVisible = true;
      }
    }
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.dialog-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
